module.exports = __webpack_public_path__ + "static/media/Trein.072969df.mp3";